import { SaveAccountPayload, UpdateAccountResponse } from '@features/accounts/query-api'

import { deleteRequest, getRequest, postRequest, postV2Request, putRequest } from '../../../../utils'

export const saveAccount = (accountData: SaveAccountPayload): Promise<UpdateAccountResponse> =>
  postRequest('/v2/accounts', { account: accountData })

type CreateAccountFromTemplateResponse = UpdateAccountResponse

export const deleteAccount = (accountId: string) => deleteRequest(`/v2/accounts/${accountId}`)

export interface CreateAccountFromTemplatePayload {
  accountNumber: number
  description: string
  name: string
  organizationId: string
  predefinedAccountId: string
}

export const createAccountFromTemplate = ({
  accountNumber,
  description,
  name,
  organizationId,
  predefinedAccountId,
}: CreateAccountFromTemplatePayload): Promise<CreateAccountFromTemplateResponse> =>
  postV2Request({
    endpoint: `/v2/customAccounts?organizationId=${organizationId}`,
    payload: {
      record: {
        accountNumber,
        description,
        name,
        predefinedAccountId,
      },
    },
  })

export interface UpdateAccountFromTemplatePayload {
  accountId: string
  description: string
  name: string
}

export const updateAccountFromTemplate = ({
  accountId,
  description,
  name,
}: UpdateAccountFromTemplatePayload): Promise<UpdateAccountResponse> =>
  putRequest(`/v2/accounts/${accountId}`, { account: { description, name } })

export interface FetchNextAvailableAccountNumberPayload {
  organizationId: string
  predefinedAccountId: string
}

export interface FetchNextAvailableAccountNumberResponse {
  nextFreeNumber: number
}

export const fetchNextAvailableAccountNumber = ({
  organizationId,
  predefinedAccountId,
}: FetchNextAvailableAccountNumberPayload): Promise<FetchNextAvailableAccountNumberResponse> =>
  getRequest(`/v2/customAccounts/${predefinedAccountId}/nextFreeAccountNumber?organizationId=${organizationId}`)

export interface ValidateAccountNumberPayload {
  accountNumber: number
  organizationId: string
}

export interface ValidateAccountNumberResponse {
  isFree: boolean
}

export const validateAccountNumber = ({
  accountNumber,
  organizationId,
}: ValidateAccountNumberPayload): Promise<ValidateAccountNumberResponse> =>
  postRequest(`/v2/customAccounts/isAccountNumberFree?organizationId=${organizationId}`, {
    record: { accountNumber },
  })
